import script from "./AdvertisementView.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdvertisementView.vue?vue&type=script&lang=ts&setup=true"

import "./AdvertisementView.vue?vue&type=style&index=0&id=cea1e232&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MYNAVI_MP_VIEW_G_PROD/workspace/view/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cea1e232"]])

export default __exports__